import { t } from '@/i18n';

export const forgotPasswordFormSchemaMessages = {
  required: t('pages.login.schemas.messages.required'),
  minPasswordSize: t('pages.login.schemas.messages.min_password_size'),
  requiredPasswordCharacters: t('pages.login.schemas.messages.required_password_characters'),
  invalidPasswordConfirmation: t('pages.login.schemas.messages.invalid_password_confirmation'),
};
